import axios from "axios";

const blogApiUrl =
  process.env.REACT_APP_BLOG_API_URL || "https://api.blogslicer.com/api/blog";

const api = axios.create({
  baseURL: blogApiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const fetchBlogContent = (post) => {
  const token = localStorage.getItem("token");
  return api.post("/extractcontent", post, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export { fetchBlogContent };
